import Alternator from "./Alternator.js"
import LeftKillSwitch from "./LeftKillSwitch.js"
import RightKillSwitch from "./RightKillSwitch.js"
import Fridge from "./Fridge.js"
import BatteryProtect from "./BatteryProtect.js"
import SolarPanel from "./SolarPanel.js"
import SolarSet from "./SolarSet.js"
import ShoreBooster from "./ShoreBooster.js"
import SolarBooster from "./SolarBooster.js"
import StarterAccu from "./StarterAccu.js"
import StarterBooster from "./StarterBooster.js"
import DCDCBooster from "./DCDCBooster.js"
import RightFuseBox from "./RightFuseBox.js"
import Consumer from "./Consumer.js"
import Usb from "./Usb.js"
import CarSocket from "./CarSocket.js"
import CarSocketCharger from "./CarSocketCharger.js"
import LeftFuse from "./LeftFuse.js"
import RightFuse from "./RightFuse.js"
import SwitchPanel from "./SwitchPanel.js"

export default class NodeFactory {
  /**
   * Create the visual node for the given component model.
   *
   * Returns "null" if the model is missing or of a type this version of the app doesn't
   * know (e.g. a configuration saved by a newer version, or a hand edited JSON file).
   * Callers must handle "null" and skip the component instead of breaking the whole map.
   */
  static createNode (leftSide, model) {
    if ( !model || typeof model.type !== "string" ) {
      return null
    }

    let node = null
    switch (model.type) {
      case "carSocket":
        node = new CarSocket()     
        break
      case "carSocketCharger":
        node = new CarSocketCharger()     
        break
      case "cooler":
        node = new Consumer()     
        break
      case "usbConsumer":
        node = new Consumer()     
        break
      case "pressurePump":
        node = new Consumer()     
        break
      case "usb":
        node = new Usb()     
        break
      case "fridge":
        node = new Fridge()     
        break
      case "batteryProtect":
        node = new BatteryProtect()     
        break
      case "dcdcBooster":
        node = new DCDCBooster()     
        break
      case "alternator":
        node = new Alternator()     
        break
      case "starterBooster":
        node = new StarterBooster()     
        break
      case "shoreBooster":
        node = new ShoreBooster()     
        break
      case "light":
        node = new Consumer()     
        break
      case "starterAccu":
        node = new StarterAccu()     
        break
      case "switchPanel":
        node = new SwitchPanel()     
        break
      case "solarBooster":
        node = new SolarBooster()    
        break 
      case "solarSet":
        node = new SolarSet()    
        break 
      case "heater":
        node = new Consumer()    
        break 
      case "fuse":
        if ( leftSide ) {
          node = new LeftFuse()  
        } else {
          node = new RightFuse()
        }   
        break
      case "killSwitch":
        if ( leftSide ) {
          node = new LeftKillSwitch()  
        } else {
          node = new RightKillSwitch()
        }   
        break
      case "fuseBox":
        node = new RightFuseBox()
        break
      case "solarPanel":
        node = new SolarPanel()
        break
    }

    if ( node === null ) {
      return null
    }

    node.setModel(model)
    return node
  }
}
